import { serializeError } from 'serialize-error';

const getMessageFromCause = (cause?: unknown): string | undefined => {
  if (typeof cause === 'string') {
    return cause;
  }

  if (cause instanceof Error) {
    return cause.message;
  }

  if (cause && typeof cause === 'object' && 'message' in cause) {
    const maybeMessage = (cause as { message?: unknown }).message;

    return typeof maybeMessage === 'string' ? maybeMessage : undefined;
  }

  return undefined;
};

class OperationError extends Error {
  readonly errorCode: string;

  readonly cause: unknown;

  constructor(errorCode: string, cause?: unknown) {
    if (cause instanceof OperationError) {
      super(cause.message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = new.target.name;
      this.errorCode = cause.errorCode;
      this.cause = cause.cause;

      return;
    }

    const internalError = serializeError(cause);
    const message = getMessageFromCause(internalError) ?? 'Operation failed';
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = new.target.name;
    this.errorCode = errorCode;
    this.cause = serializeError(internalError);
  }
}

export default OperationError;
